// extracted by mini-css-extract-plugin
module.exports = {"star":"Rating_star__3oCv3"};